import $ from 'jquery';

const addQuantity = () => {
	const el = {
		wrapper: '.quantity-plus-minus',
		btnMinus: '.quantity-minus',
		btnPlus: '.quantity-plus',
		inputQty: '.quantity-input',
		wooQty: '.qty',
	};

	if ($(el.wrapper).length < 1) return;

	const updateButtonStates = (input) => {
		const currentVal = parseInt(input.val()) || 1;
		const minVal = parseInt(input.attr('min')) || 1;
		const wrapper = input.closest(el.wrapper);

		wrapper.find(el.btnMinus).prop('disabled', currentVal <= minVal);
	};

	const syncWithWooCommerce = (customInput) => {
		const wooInput = $(el.wooQty).first();
		if (wooInput.length > 0) {
			wooInput.val(customInput.val()).trigger('change');
		}
	};

	const init = () => {
		const wooInput = $(el.wooQty).first();
		const customInput = $(el.inputQty).first();

		if (wooInput.length > 0 && customInput.length > 0) {
			const initialQty = parseInt(wooInput.val()) || 1;
			customInput.val(initialQty);
			updateButtonStates(customInput);
		}

		$(document).on('click', el.btnPlus, function () {
			const input = $(this).siblings(el.inputQty);
			let currentVal = parseInt(input.val()) || 1;

			if (!isNaN(currentVal)) {
				input.val(currentVal + 1).trigger('change');
				updateButtonStates(input);
				syncWithWooCommerce(input);
			}
		});

		$(document).on('click', el.btnMinus, function () {
			const input = $(this).siblings(el.inputQty);
			const minVal = parseInt(input.attr('min')) || 1;
			let currentVal = parseInt(input.val()) || minVal;

			if (!isNaN(currentVal) && currentVal > minVal) {
				input.val(currentVal - 1).trigger('change');
				updateButtonStates(input);
				syncWithWooCommerce(input);
			}
		});

		$(document).on('input change', el.inputQty, function () {
			const input = $(this);
			const minVal = parseInt(input.attr('min')) || 1;
			let currentVal = parseInt(input.val());

			if (isNaN(currentVal) || currentVal < minVal) {
				input.val(minVal);
			}
			updateButtonStates(input);
			syncWithWooCommerce(input);
		});

		$(document).on('change', el.wooQty, function () {
			const wooInput = $(this);
			const customInput = $(el.inputQty).first();

			if (customInput.length > 0) {
				const qty = parseInt(wooInput.val()) || 1;
				customInput.val(qty);
				updateButtonStates(customInput);
			}
		});

		$(el.wrapper).each(function () {
			const input = $(this).find(el.inputQty);
			updateButtonStates(input);
		});
	};

	init();
};

try {
	addQuantity();
} catch (error) {
	console.log('add quantity error : ' + error);
}
